import { render, staticRenderFns } from "./WarningTriangleFilled.vue?vue&type=template&id=35c392d0&"
import script from "./WarningTriangleFilled.vue?vue&type=script&setup=true&lang=js&"
export * from "./WarningTriangleFilled.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports